import axios from 'axios';
import {backendHost} from '../../config';

export const postLandings = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/landings`, params);
};